<template>
  <div class="modatta-navbar">
    <div
      class="modatta-container"
      :class="{ 'navbar-item--blue': color === 'blue' }"
    >
      <div class="start">
            <router-link to="/" class="logo logo--desktop">
                <img src="/svg/modatta-logo.svg" alt="Modatta Logo" />
            </router-link>
            <router-link to="/" class="logo logo--mobile">
                <img src="/svg/modatta-icon.svg" alt="Modatta Logo" />
            </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["color"],
};
</script>
